import { ErrorPage as ErrorPageProps, SiteSettings } from '@/@types/content';
import withNav from '../hocs/withNav';
import ContentArea from '../cms/ContentArea';
import RichText from '../cms/RichText';
import { useEffect, useRef } from 'react';
import { useLazyGetRedirectForUrlQuery } from '@/redux/api/client/redirect';
import { appInsights } from '@/lib/ApplicationInsightsService';
import Shimmer from '../ui/Shimmer';

const ErrorPageComponent: React.FC<ErrorPageProps & SiteSettings> = ({
  mainBody,
  mainContentArea
}) => {
  const [getReidrectForUrlQuery] = useLazyGetRedirectForUrlQuery();
  const firstLoad = useRef(true);
  const isWaiting = useRef(true);
  const isRequesting = useRef(false);
  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
    }
    const possibleRedirectTo =
      (document?.location?.pathname ?? '') + (document?.location?.search ?? '');
    if (possibleRedirectTo) {
      if (!isRequesting.current) {
        isRequesting.current = true;
        getReidrectForUrlQuery(possibleRedirectTo)
          .unwrap()
          .then(response => {
            if (response) {
              document.location.href = response;
            } else {
              isWaiting.current = false;
            }
          })
          .catch(e => {
            appInsights.trackException(e);
            isWaiting.current = false;
          });
      }
    } else {
      isWaiting.current = false;
    }
  });

  return isWaiting.current ? (
    <Shimmer className="h-64 w-full" />
  ) : (
    <>
      <RichText content={mainBody} className="container module-spacing" />
      <ContentArea components={mainContentArea} propertyName="MainContentArea" />
    </>
  );
};

const ErrorPage = withNav(ErrorPageComponent);
export default ErrorPage;
